import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
//=====================================================================
import { useTranslation } from "react-i18next";
import { SaleCheckbox, useStylesContainers } from '../../../../St/comps/UseStyle';
import { ButtonBase, Divider, FormControlLabel, Hidden } from '@material-ui/core';

export default function FoundationsThirdPanel(props) {

    const {
        changTField,
        params,
        clasess,
        handleHeaderFileInputChange,
        handleFooterFileInputChange,
        fileHeaderImg,
        fileFooterImg,
        deleteFooter,
        deleteHeader,
        changeHeaderDelete,
        changeFooterDelete
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();


    const clsConts = useStylesContainers();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);
    const secondColor = "#be151f";

    const [showPic, setShowPic] = useState(false);
    return (
        <React.Fragment>
            <Grid container justifyContent="center" >
                <Grid
                    item
                    container


                    justifyContent='center'

                    lg={12} md={12} sm={12} xs={12}
                >
                    <Hidden only={["xs"]}>

                        <Grid item container lg={12} md={12} sm={12} xs={12}>
                            <Grid item container lg={2} md={2} sm={3} xs={3}>

                                <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="showPaid"
                                        value="showPaid"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={deleteHeader}
                                                onChange={(e) => {
                                                    changeHeaderDelete("header");
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="Delete Header"

                                        labelPlacement="end"
                                    />
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="deleteFooter"
                                        value="deleteFooter"
                                        name="deleteFooter"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={deleteFooter}
                                                onChange={(e) => {
                                                    changeFooterDelete("footer");
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="Delete Footer"

                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                className={clasess.imageLogo}
                                item
                                lg={9} md={9} sm={8} xs={8}
                            >
                                <input
                                    accept="image/*"
                                    className={clasess.input}
                                    id="contained-button-file"
                                    multiple
                                    name="Logo" //value={data.Logo.toString()}
                                    type="file"
                                    onChange={handleHeaderFileInputChange}
                                />
                                <label htmlFor="contained-button-file">
                                    <ButtonBase
                                        style={{ border: "solid 1px" }}
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                    >
                                        <img
                                            src={` ${fileHeaderImg.baseURL ? fileHeaderImg.code8 : fileHeaderImg.code64}
                  ${params?.header_img}
                  `}
                                            style={{ height: 100, minWidth: "21cm" }}
                                            alt={params?.nameA}
                                        />
                                    </ButtonBase>
                                </label>
                            </Grid>
                        </Grid>

                    </Hidden>

                    <Hidden smUp={["sm"]}>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="showPaid"
                                        value="showPaid"
                                        name="showPaid"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={deleteHeader}
                                                onChange={(e) => {
                                                    changeHeaderDelete("header");
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="Delete Header"

                                        labelPlacement="end"
                                    />
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <FormControlLabel
                                        id="deleteFooter"
                                        value="deleteFooter"
                                        name="deleteFooter"
                                        className={claslbl.clor}
                                        control={
                                            <SaleCheckbox
                                                checked={deleteFooter}
                                                onChange={(e) => {
                                                    changeFooterDelete("footer");
                                                }}
                                                color="primary"
                                            />
                                        }
                                        label="Delete Footer"

                                        labelPlacement="end"
                                    />
                                </Grid>
                        <Grid item container lg={12} md={12} sm={12} xs={12}>
                            <Grid
                                className={clasess.imageLogo}
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                            >
                                <input
                                    accept="image/*"
                                    className={clasess.input}
                                    id="contained-button-file"
                                    multiple
                                    name="Logo" //value={data.Logo.toString()}
                                    type="file"
                                    onChange={handleHeaderFileInputChange}
                                />
                                <label htmlFor="contained-button-file">
                                    <ButtonBase
                                        style={{ border: "solid 1px" }}
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                    >
                                        <img
                                            src={` ${fileHeaderImg.baseURL ? fileHeaderImg.code8 : fileHeaderImg.code64}
                  ${params?.header_img}
                  `}
                                            style={{ height: 100, minWidth: "100%" }}
                                            alt={params?.nameA}
                                        />
                                    </ButtonBase>
                                </label>
                            </Grid>
                        </Grid>
                    </Hidden>

                    <Divider style={{ background: secondColor, height: 1.5 }} />
                    <Grid style={{ paddingTop: "0.1cm" }}>
                        <Divider
                            style={{ background: secondColor, height: 1.5 }}
                        />
                    </Grid>
                    <h3>{"راس الصفحة"}</h3>

                    <Grid item container lg={12} md={12} sm={12} xs={12} spacing={1}>

                        <Grid item container lg={6} md={6} sm={6} xs={12}>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc1_header_ar"
                                    label="وصف 1"
                                    type="text"
                                    name="Disc1_header_ar"
                                    value={params?.Disc1_header_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc1_header_ar")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc2_header_ar"
                                    label="وصف 2"
                                    type="text"
                                    name="Disc2_header_ar"
                                    value={params?.Disc2_header_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc2_header_ar")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc3_header_ar"
                                    label="وصف 3"
                                    type="text"
                                    name="Disc3_header_ar"
                                    value={params?.Disc3_header_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc3_header_ar")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc4_header_ar"
                                    label="وصف 4"
                                    type="text"
                                    name="Disc4_header_ar"
                                    value={params?.Disc4_header_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc4_header_ar")}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container lg={6} md={6} sm={6} xs={12}>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc1_header_ar"
                                    label="Desc1"
                                    type="text"

                                    name="Disc1_header_en"
                                    value={params?.Disc1_header_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc1_header_en")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc2_header_en"
                                    label="Desc2"
                                    type="text"
                                    name="Disc2_header_en"
                                    value={params.Disc2_header_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc2_header_en")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc3_header_en"
                                    label="Desc3"
                                    type="text"
                                    name="Disc3_header_en"
                                    value={params.Disc3_header_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc3_header_en")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc4_header_ar"
                                    label="Desc4"
                                    type="text"
                                    name="Disc4_header_en"
                                    value={params.Disc4_header_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc4_header_en")}
                                />
                            </Grid>
                        </Grid>

                    </Grid>

                    <Divider style={{ background: secondColor, height: 1.5 }} />
                    <Grid style={{ paddingTop: "0.1cm" }}>
                        <Divider
                            style={{ background: secondColor, height: 1.5 }}
                        />
                    </Grid>
                    <h3>{"ذيل الصفحة"}</h3>
                    <Grid item container lg={12} md={12} sm={12} xs={12} spacing={1}>

                        <Grid item container lg={6} md={6} sm={6} xs={12} >
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc1_footer_ar"
                                    label="وصف 1"
                                    type="text"
                                    name="Disc1_footer_ar"
                                    value={params.Disc1_footer_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc1_footer_ar")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc2_footer_ar"
                                    label="وصف 2"
                                    type="text"
                                    name="Disc2_footer_ar"
                                    value={params.Disc2_footer_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc2_footer_ar")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc3_footer_ar"
                                    label="وصف 3"
                                    type="text"
                                    name="Disc3_footer_ar"
                                    value={params.Disc3_footer_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc3_footer_ar")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc3_footer_ar"
                                    label="وصف 4"
                                    type="text"
                                    name="Disc3_footer_ar"
                                    value={params.Disc4_footer_ar}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc4_footer_ar")}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container lg={6} md={6} sm={6} xs={12}>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc1_footer_en"
                                    label="Desc1"
                                    type="text"
                                    name="Disc1_footer_en"
                                    value={params.Disc1_footer_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc1_footer_en")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc1_footer_en"
                                    label="Desc2"
                                    type="text"
                                    name="Disc1_footer_en"
                                    value={params.Disc2_footer_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc2_footer_en")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc3_header_en"
                                    label="Desc3"
                                    type="text"
                                    name="Disc1_footer_en"
                                    value={params.Disc3_footer_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc3_footer_en")}
                                />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingBottom: "0.5rem", direction: "ltr" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="Disc4_header_ar"
                                    label="Desc4"
                                    type="text"
                                    name="Disc4_footer_en"
                                    value={params.Disc4_footer_en}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("Disc4_footer_en")}
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                    <Hidden only={["xs"]}>


                        <Grid
                            className={clasess.imageLogo}
                            item
                            lg={12} md={12} sm={12} xs={12}
                        >
                            <input
                                accept="image/*"
                                className={clasess.input}
                                id="contained-button-file1"
                                multiple
                                name="footer_image" //value={data.Logo.toString()}
                                type="file"
                                onChange={handleFooterFileInputChange}
                            />
                            <label htmlFor="contained-button-file1">
                                <ButtonBase
                                    style={{ border: "solid 1px" }}
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                >
                                    <img
                                      src={`${
                                        fileFooterImg.baseURL
                                          ? fileFooterImg.code8
                                          : fileFooterImg.code64
                                      }
                               ${params.footer_img}`}
                                        style={{ height: 100, minWidth: "21cm" }}
                                        alt={params?.nameA}
                                    />
                                </ButtonBase>
                            </label>
                        </Grid>
                    </Hidden>

                    <Hidden smUp={["sm"]}>
                        <Grid item container lg={12} md={12} sm={12} xs={12}>
                            <Grid
                                className={clasess.imageLogo}
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                            >
                                <input
                                    accept="image/*"
                                    className={clasess.input}
                                    id="contained-button-file"
                                    multiple
                                    name="footer_image" //value={data.Logo.toString()}
                                    type="file"
                                    onChange={handleFooterFileInputChange}
                                />
                              <label htmlFor="contained-button-file1">
                                <ButtonBase
                                    style={{ border: "solid 1px" }}
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                >
                                    <img
                                      src={`${
                                        fileFooterImg.baseURL
                                          ? fileFooterImg.code8
                                          : fileFooterImg.code64
                                      }
                               ${params.footer_img}`}
                                        style={{ height: 100, minWidth:"100%" }}
                                        alt={params?.nameA}
                                    />
                                </ButtonBase>
                            </label>
                            </Grid>
                        </Grid>
                    </Hidden>

                </Grid>
            </Grid>



        </React.Fragment>
    );

}